import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthService {

    private token: string = null;
    constructor(
        private router: Router,
        private permissionsService: NgxPermissionsService,
        private http: HttpClient,
        private dialogRef: MatDialog
    ) {
    }
    public isAuthenticated(): boolean {
        return (this.getToken() != null);
    }

    login(user, pass, callback) {
        this.http.post('https://www.securfly.it/login/api/identity/auth/v1.1/authenticate', { "username": user, "password": pass })
            .subscribe((data : any) => {
                this.token = data.data.token;
                sessionStorage.setItem('token', this.token);
                sessionStorage.setItem('region', data.data.user.region);
                callback(true, data);
            }, async error => {
                console.log("ERRORE", error);
                callback(false, error);
            });
    }

    resetPassword(user, pass, callback) {
        this.http.post('https://www.securfly.it/login/api/identity/auth/v1.1/password-reset', { "username": user, "password": pass })
            .subscribe((data : any) => {
                callback(true, data);
            }, async error => {
                callback(false);
            });
    }

    getToken() {
        return sessionStorage.getItem('token');
    }

    logout() {
        this.dialogRef.closeAll();
        this.token = null;
        sessionStorage.clear();
        this.permissionsService.flushPermissions();
        this.router.navigate(['login']);
    }

    redirectTo(uri: string) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate([uri]));
    }
}